import { CSSObject } from '@chakra-ui/react';
import { TSelected } from './Filters.styles';

export const FlexFilterWrapper: CSSObject = {
  px: '0',
  py: '0',
  my: '3',
  h: '9',
  position: 'inherit',
};

export const ButtonFilter = () => ({
  color: 'alpha.300',
});

export const IconCheck = ({ selected }: TSelected) => ({
  bg: selected ? 'beta.300' : 'blackAlpha.500',
  color: selected ? 'alpha.400' : 'whiteAlpha.700',
  boxShadow: '0px 1px 0px 0px #000 inset',
  path: {
    display: selected ? 'block' : 'none',
  },
});

export const IconRace = ({ selected }: TSelected) => ({
  color: selected ? 'beta.300' : 'whiteAlpha.700',
});

export const Divider: CSSObject = {
  bg: 'alpha.800',
  display: 'block',
  h: '7',
  my: 'auto',
  mx: '4',
};

export const TextFilterLabel: CSSObject = {
  color: 'white',
};

export const FlexRaceTypeWrapper: CSSObject = {
  columnGap: '2',
  mr: '0',
};
